import React, { FC } from "react";
import { Box, Paper, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Container } from "../../../../../components/layouts/Container/Container";
import { Loading } from "../../../../../components/layouts/Loading";
import { SubMenu } from "../../../../../components/common/SubMenu";
import { SUB_MENU } from "../../../../../constants/menu";
import { StockAdjustmentList } from "./StockAdjustmentList";
import { CanAccessFunctionality } from "../../../../../components/common/Privilege/FunctionPrivilegeCheck";
import { E_FUNCTIONALITY } from "../../../../../utils/functionalityVariable";

const ADJUSTMENT_TABS = [
  {
    value: "yarn",
    label: "Yarn",
    functionality: E_FUNCTIONALITY.sub_menu_inventory_adjust_tab_yarn,
  },
  {
    value: "accessory",
    label: "Accessory",
    functionality: E_FUNCTIONALITY.sub_menu_inventory_adjust_tab_accessory,
  },
];

export const StockAdjustment: FC = () => {
  const allowedTabs = ADJUSTMENT_TABS.filter((tab) =>
    CanAccessFunctionality({ user_functionalities: [tab.functionality] })
  );
  const [tabValue, setTabValue] = React.useState<string>(
    allowedTabs[0]?.value ?? ""
  );

  return (
    <Container>
      <SubMenu list={SUB_MENU["stock"]} />
      <Box component={Paper}>
        <React.Suspense fallback={<Loading />}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={(_e, v) => setTabValue(v)}>
                {allowedTabs.map((tab) => (
                  <Tab key={tab.value} label={tab.label} value={tab.value} />
                ))}
              </TabList>
            </Box>
            {allowedTabs.map((tab) => (
              <TabPanel key={tab.value} value={tab.value}>
                <StockAdjustmentList
                  category={tab.value as "yarn" | "accessory"}
                  title={`${tab.label} adjustments`}
                />
              </TabPanel>
            ))}
          </TabContext>
        </React.Suspense>
      </Box>
    </Container>
  );
};